export default {
	notification_health: 'Stan powiadomień',
	notification_health_summary: 'Podsumowanie',
	notification_health_loading: 'Sprawdzanie stanu powiadomień...',
	notification_health_refresh: 'Odśwież',
	notification_health_fix: 'Co zrobić',
	notification_health_unavailable: 'Nie udało się załadować stanu powiadomień',
	notification_health_healthy: 'Sprawny',
	notification_health_blocked: 'Zablokowany',
	notification_health_degraded: 'Wymaga uwagi',
	notification_health_no_app_user: 'Brak logowania w aplikacji',
	notification_health_unknown: 'Nieznany',
	notification_health_app_version: 'Wersja aplikacji',
	notification_health_last_delivery: 'Ostatnia dostawa',
	notification_health_time_just_now: 'przed chwilą',
	notification_health_time_minutes: '{count} min temu',
	notification_health_time_hours: '{count} godz. temu',
	notification_health_time_days: '{count} dni temu',
	notification_health_time_unknown: 'nieznany',
	notification_health_summary_healthy: 'Powiadomienia powinny działać',
	notification_health_summary_no_app_user: 'Sprzątacz nie zalogował się do aplikacji mobilnej',
	notification_health_summary_blocked_no_token: 'Brak tokena push — sprzątacz musi otworzyć aplikację i się zalogować',
	notification_health_summary_blocked_off: 'Powiadomienia są wyłączone w aplikacji',
	notification_health_check_portal_contact_label: 'Kontakt w portalu istnieje',
	notification_health_check_portal_active_label: 'Kontakt aktywny',
	notification_health_check_portal_rooms_label: 'Przypisane pokoje',
	notification_health_check_portal_shifts_label: 'Przypisane zmiany',
	notification_health_check_app_user_label: 'Zalogowany w aplikacji mobilnej',
	notification_health_check_push_token_label: 'Token push zarejestrowany',
	notification_health_check_notification_mode_label: 'Tryb powiadomień',
	notification_health_check_time_schedule_label: 'W oknie czasu powiadomień',
	notification_health_check_ios_geo_filter_label: 'Filtr lokalizacji iOS',
	notification_health_check_recent_push_attempt_label: 'Ostatnia próba push (48 h)',
	notification_health_check_last_push_ignored_label: 'Ostatni sygnał nie został wysłany',
	notification_health_check_recent_push_delivered_label: 'Ostatnia dostawa push (48 h)',
	notification_health_detail_portal_contact_found: 'Znaleziono w portalu',
	notification_health_detail_portal_contact_missing: 'Nie znaleziono rekordu kontaktu',
	notification_health_detail_portal_active_active: 'Aktywny',
	notification_health_detail_portal_active_inactive: 'Nieaktywny',
	notification_health_detail_portal_rooms_assigned: '{count} pokoi',
	notification_health_detail_portal_rooms_none: 'Brak przypisanych pokoi',
	notification_health_detail_portal_shifts_assigned: '{count} zmian',
	notification_health_detail_portal_shifts_none: 'Brak przypisanych zmian',
	notification_health_detail_app_user_logged_in: 'Wersja aplikacji {version}, ostatnia synchronizacja {lastSync}',
	notification_health_detail_app_user_never: 'Nigdy się nie logował',
	notification_health_detail_push_token_present: 'Token FCM obecny',
	notification_health_detail_push_token_empty: 'Token jest pusty',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'Aktualny czas mieści się w harmonogramie',
	notification_health_detail_time_schedule_outside: 'Aktualny czas jest poza skonfigurowanym harmonogramem',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'Brak prób push w ostatnich 48 godzinach',
	notification_health_detail_last_push_ignored: 'Ostatnie żądanie push zostało zignorowane (servik nie skonfigurowany dla obszaru roboczego)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'Brak udanych dostaw w ostatnich 48 godzinach',
	notification_health_fix_portal_contact: 'Utwórz tego sprzątacza w panelu Użytkownicy',
	notification_health_fix_portal_active: 'Włącz przełącznik Aktywny dla tego sprzątacza',
	notification_health_fix_portal_rooms: 'Przypisz co najmniej jeden pokój temu sprzątaczowi',
	notification_health_fix_portal_shifts: 'Przypisz co najmniej jedną zmianę',
	notification_health_fix_app_user: 'Sprzątacz musi zainstalować aplikację i zalogować się tym numerem telefonu',
	notification_health_fix_push_token: 'Poproś sprzątacza o otwarcie aplikacji, zezwolenie na powiadomienia w ustawieniach iOS i ponowne logowanie',
	notification_health_fix_notification_mode: 'Zmień tryb powiadomień z Wył. na Zawsze w aplikacji',
	notification_health_fix_time_schedule: 'Poczekaj do zaplanowanego okna lub zmień tryb na Zawsze',
	notification_health_fix_ios_geo_filter: 'Sprzątacz jest poza strefą powiadomień — poproś go o otwarcie aplikacji na miejscu',
	notification_health_fix_last_push_ignored: 'Sprawdź konfigurację servik obszaru roboczego dla pokoju, który wywołał sygnał',
	notification_health_fix_recent_push_delivered_filters: 'Sprawdź filtry powiadomień lub ustawienia urządzenia',
	notification_health_fix_recent_push_delivered_token: 'Najpierw zarejestruj token push',
	notification_health_mode_on: 'Zawsze',
	notification_health_mode_off: 'Wył.',
	notification_health_mode_time: 'Według czasu',
	notification_health_mode_location: 'Według lokalizacji',
	notification_health_filter_on: 'Wł.',
	notification_health_filter_off: 'Wył.',
};
